import Vue from 'vue';
import Router from 'vue-router';
import Dashboard from '@/components/Dashboard';
import Actions from '@/components/Actions';
import Meetings from '@/components/Meetings';
import MeetingView from '@/components/MeetingView';
import MeetingPreview from '@/components/MeetingPreview';
import MeetingHold from '@/components/MeetingHold';
import PlanMeeting from '@/components/PlanMeeting';
import Reports from '@/components/Reports';
import Profile from '@/components/Profile';
import Frame from '@/components/Frame';
import Login from '@/components/Login';
import ActionsDetail from '@/components/ActionsDetail';
import EditAction from '@/components/EditAction';
import Report from '@/components/Report';
import ResetPassword from '@/components/ResetPassword';
import WrongURL from '@/components/WrongURL';

Vue.use(Router);

const routes = new Router({
  routes: [
    {
      path: '',
      name: 'frame',
      component: Frame,
      children: [
        {
          path: '/dashboard',
          name: 'Dashboard',
          component: Dashboard,
          meta: {
            parentRoute: null,
            displayName: false
          }
        },
        {
          path: '/actions',
          name: 'Actions',
          component: Actions,
          meta: {
            parentRoute: null,
            displayName: false
          }
        },
        {
          path: '/action/:id',
          name: 'Action',
          component: ActionsDetail,
          meta: {
            parentRoute: ["/actions"],
            parentRouteName: ["Actions"],
            displayName: true
          }
        },
        {
          path: '/editAction/:id',
          name: "Edit action",
          component: EditAction,
          meta: {
            parentRoute: ["/actions"],
            parentRouteName: ["Actions"],
            displayName: true
          }
        },
        {
          path: '/meetings',
          name: 'My Meetings',
          component: Meetings,
          meta: {
            parentRoute: null,
            displayName: false
          }
        },
        {
          path: '/meeting/:id',
          name: 'Meeting',
          component: MeetingView,
          meta: {
            parentRoute: ["/meetings"],
            parentRouteName: ["My meetings"],
            displayName: true
          }
        },
        {
          path: '/planmeeting/:id?',
          name: 'Plan meeting',
          component: PlanMeeting,
          meta: {
            parentRoute: null,
            displayName: false
          }
        },
        {
          path: '/reports',
          name: 'Reports',
          component: Reports,
          meta: {
            parentRoute: null,
            displayName: false
          }
        },
        {
          path: '/report/:id',
          name: 'Report',
          component: Report,
          meta: {
            parentRoute: ["/reports"],
            parentRouteName: ["Reports"],
            displayName: true
          }
        },
        {
          path: '/profile',
          name: 'My Profile',
          component: Profile,
          meta: {
            parentRoute: null,
            displayName: false
          }
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login
    },
    {
      path: '/recover/:user_id/:token',
      name: 'Reset password',
      component: ResetPassword
    },
    {
      path: '/haveMeeting',
      name: 'Have Meeting',
      component: MeetingHold,
      children: [
        {
          path: ':id',
          name: 'havemeetingid'
        }
      ]
    },
    {
      path: '/meetingpreview/:id',
      name: 'Meeting Preview',
      component: MeetingPreview,
      meta: {
        parentRoute: ["/meetings"],
        parentRouteName: ["My meetings"],
        displayName: true
      }
    },


    // CATCH ALL, MUST BE AT BOTTOM OF THIS DOCUMENT AT ALL TIMES
    {
      path: '/*',
      name: 'Wrong URL',
      component: WrongURL
    }
  ]
});
let loggedIn = true;

export default routes;




// WEBPACK FOOTER //
// ./src/router/index.js